import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { ServerSessionProvider } from './auth/ServerSessionProvider'
import './styles/global.css'

// Stamp the running build so a tab left open across a deploy is identifiable
// (an SPA never re-fetches index.html without a reload).
console.info(`%cAnimus Arena%c build ${__BUILD_SHA__} · ${__BUILD_TIME__}`,
  'font-weight:bold', 'color:#888')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ServerSessionProvider>
      <App />
    </ServerSessionProvider>
  </React.StrictMode>,
)
